import {
  GET_CONTACT_LIST,
  GET_CONTACT_LIST_FAIL,
  GET_CONTACT_LIST_SUCCESS,
  GET_CONTACT_LIST_DETAIL,
  GET_CONTACT_LIST_DETAIL_FAIL,
  GET_CONTACT_LIST_DETAIL_SUCCESS
} from "./actionTypes"

export const getContactLists = (pagination) => ({
  type: GET_CONTACT_LIST,
  payload: pagination
})

export const getContactListsSuccess = contactLists => ({
  type: GET_CONTACT_LIST_SUCCESS,
  payload: contactLists,
})

export const getContactListsFail = error => ({
  type: GET_CONTACT_LIST_FAIL,
  payload: error,
})

export const getContactListDetail = (id) => ({
  type: GET_CONTACT_LIST_DETAIL,
  payload: id
})

export const getContactListDetailSuccess = contactListDetail => ({
  type: GET_CONTACT_LIST_DETAIL_SUCCESS,
  payload: contactListDetail,
})

export const getContactListDetailFail = error => ({
  type: GET_CONTACT_LIST_DETAIL_FAIL,
  payload: error,
})


